<template>
  <section class="py-10">
    <h2 class="sr-only">Business serives</h2>
    <div class="container grid gap-x-20 gap-y-10 md:grid-cols-2">
      <div>
        <h3>Hotels</h3>
        <p>Enhance your guest experience with our exclusive chauffeur service. Our premium vehicles can be stationed at your hotel, ready to provide seamless transfers and luxurious city tours. Partner with us under a simple agreement, and not only will your guests enjoy world-class transportation, but you’ll also earn a 5% commission on every ride booked through your hotel. Elevate your service offering with ease—book via WhatsApp and let us take care of the rest.</p>
      </div>
      <div>
        <h3>Cruise lines</h3>
        <p>We can elevate your guests' experience with a chauffeured transfer that provides a seamless door-to-door experience. Our local expertise with port and airport pickups ensures that your guests will arrive at their destination in style and comfort. Plus, our fully white-label complimentary ride booking solution is available to provide a customized experience that aligns with your brand.</p>
      </div>
      <div>
        <h3>Corporations</h3>
        <p>Simplify your business travel needs with our executive chauffeur service. Whether it’s airport transfers, corporate events, or city commutes, our premium vehicles and professional drivers deliver unmatched reliability and comfort. With a straightforward contract, enjoy convenient monthly billing and a detailed summary of all rides. Payments are due the first week of each month to ensure our drivers continue providing exceptional service. Book effortlessly via WhatsApp or email and let us handle the logistics.</p>
      </div>
      <div>
        <h3>Travel agents</h3>
        <p>Partner with us to provide your clients with a seamless, luxurious transportation experience. Our white-label solution allows you to integrate our premium limousine service into your brand effortlessly—simply add your commission to our fixed rates. Prefer a direct partnership? Earn up to 5% commission on every ride booked through your agency.<br>

For full-day packages, we take care of all expenses related to the driver and the vehicle, including fuel, meals, and accommodation. Your clients will enjoy a first-class ride while you benefit from an additional revenue stream. Contact us via WhatsApp or email to learn more about how we can enhance your services.</p>
      </div>
    </div>
  </section>

  <section class="container py-10 text-center">
    <h2>Our partners</h2>
    <p>We are proud to work with these esteemed organizations:</p>
    <div class="flex flex-wrap items-center justify-center gap-10 my-10 opacity-60">
      <a href="https://czechtourism.cz/" target="_blank">
        <img class="h-12" src="/images/partners/czechtourism.svg" alt="Czech Tourism" />
      </a>
      <a href="https://ctp.eu/" target="_blank">
        <img class="h-12" src="/images/partners/ctp.svg" alt="CTP" />
      </a>
      <a href="https://www.manifesto.city/" target="_blank">
        <img class="h-12" src="/images/partners/manifesto.png" alt="Manifesto" />
      </a>
    </div>
  </section>

  <section class="container p-10 my-10 text-center border rounded-lg shadow">
    <h2>Contact us</h2>
    <p class="my-8 text-2xl text-center">
      <UButton href="mailto:info@driveczech.com" leading-icon="i-heroicons-envelope" aria-label="E-mail">
        info@driveczech.com
      </UButton>
    </p>
  </section>

  <ContentMission />

</template>
